import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for when the receiving team fields a ball off the rebound net on a kickoff (Indoor Football).
 * The receiving team gains possession.
 */
export default class ReboundNetFieldedReceiving extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState ===
            FootballState.ReboundNetFieldedReceiving
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { fieldedBy, fieldedAt } = fragment;

        // Receiving team gains possession
        if (fieldedBy) {
            gameContext.setPossessionForTeamId(fieldedBy.teamId);
            gameContext.setCurrentPlayerInPossession(fieldedBy);
        }
        if (fieldedAt || fieldedAt === 0) {
            gameContext.setFieldPosition(fieldedAt);
        }
        ruleContext.setAwardFirstDown(true);
    }
}
